import {Routes} from "@angular/router";
import {OrderComponent} from "./order/order.component";


export const publicRoutes: Routes = [
    {
        path: '',
        children: [
            {
                path: 'order/:key',
                component: OrderComponent,
            }

        ]
    },
    {
        path: '**',
        redirectTo: '/public/main/order',
    }

];
